import { type Provider } from '@/lib/gas'

const buildUrl = (provider: Provider, redirectUri: string) => {
  const url = new URL('/oauth2/authorize', provider.domain)
  url.searchParams.append('identity_provider', provider.provider)
  url.searchParams.append('client_id', provider.clientId)
  url.searchParams.append('response_type', 'CODE')
  url.searchParams.append('scope', provider.authScope)
  url.searchParams.append('redirect_uri', redirectUri)

  return url.toString()
}

export const getOAuthLinks = (
  origin: string,
  providers: (Provider & { label: string })[],
): { loginUrl: string; type: string; label: string }[] => {
  return providers.map((provider) => {
    const redirectUri = `${origin}/auth/login?provider=${provider.type}`
    return {
      label: provider.label,
      loginUrl: buildUrl(provider, redirectUri),
      type: provider.type,
    }
  })
}
